import styled from '@emotion/styled';

export const SystemWebhookBanner = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.color.blue200}20;
    color: ${({ theme }) => theme.color.blue200};
    border-radius: ${({ theme }) => theme.radius.main};
    margin: ${({ theme }) => theme.spacing[4]};
    margin-bottom: 0;
    font-size: ${({ theme }) => theme.font.size.normal};
`;
